import { apiClient, downloadOrgMediaFile, orgApiPath } from '@/core/api';
import type { Page, RenderJobSummary, RenderOutputResolution } from '@/types/api';
import { listQueryString, type ListPageParams } from '@/services/pagination';

export async function listOrganizationRenders(
  params: ListPageParams = {},
): Promise<Page<RenderJobSummary>> {
  return apiClient<Page<RenderJobSummary>>(
    orgApiPath(`/renders?${listQueryString(params)}`),
  );
}

export async function listCreativeRenders(
  creativeId: number,
  params: ListPageParams = {},
): Promise<Page<RenderJobSummary>> {
  return apiClient<Page<RenderJobSummary>>(
    orgApiPath(`/creatives/${creativeId}/renders?${listQueryString(params)}`),
  );
}

export async function startRenderJob(
  creativeId: number,
  outputResolution: RenderOutputResolution,
): Promise<number> {
  const row = await apiClient<{ id: number | null }>(
    orgApiPath(`/creatives/${creativeId}/render`),
    {
      method: 'POST',
      body: JSON.stringify({ output_resolution: outputResolution }),
    },
  );
  if (row.id == null) {
    throw new Error('Render job missing id');
  }
  return row.id;
}

export async function downloadRenderContentFile(
  creativeId: number,
  renderId: number,
  filename: string,
): Promise<void> {
  const base = filename.endsWith('.mp4') ? filename : `${filename}.mp4`;
  downloadOrgMediaFile(`/creatives/${creativeId}/renders/${renderId}/content`, base);
}
